import { getElementParents } from '../helpers/general';

document.querySelectorAll('.card-toggle-header').forEach((toggleHeader) => {
  toggleHeader.addEventListener('click', () => {
    const toggleParents = getElementParents(toggleHeader, '.card-toggle');

    toggleParents.forEach((toggleParent) => {
      toggleParent.classList.toggle('open');
    });
  });
});

document.querySelectorAll('.list-card-toggle a').forEach((toggleLink) => {
  toggleLink.addEventListener('click', () => {
    const category = document.querySelector('#' + toggleLink.dataset.categoryId);

    category.classList.add('open');
  });
});
